import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { addCommas } from '../../../components/converter';

const toToman = (value) => {
  if (value === undefined || value === null || value === '') return '-';
  const toman = Math.round(Number(value) / 10);
  if (!Number.isFinite(toman)) return '-';
  return addCommas(toman);
};

const TransactionCard = ({ item }) => {
  const isWithdraw = item?.actionType === 'withdraw';
  const amountColor = isWithdraw ? '#d32f2f' : '#12a000';
  const amountPrefix = isWithdraw ? '-' : '+';

  return (
    <Box
      sx={{
        bgcolor: 'background.card',
        p: '12px',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '16px',
        width: '100%',
        mb: 1.5,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Typography fontWeight={700} fontSize={16}>
          {item?.actionTypeName || item?.transactionType || 'تراکنش'}
        </Typography>
        <Typography fontWeight={800} fontSize={16} sx={{ color: amountColor }}>
          {amountPrefix}
          {toToman(item?.amount)}
        </Typography>
      </Stack>
      <Divider sx={{ mb: 1 }} />
      <Stack spacing={0.75}>
        <Row label="مانده" value={`${toToman(item?.remainingBalance)} تومان`} />
        <Row label="تاریخ" value={item?.localCreatedAt || '-'} />
        <Row label="شناسه تراکنش" value={item?.referenceNo || '-'} />
        <Row label="توضیحات" value={item?.description || '-'} />
      </Stack>
    </Box>
  );
};

const Row = ({ label, value }) => (
  <Stack direction="row" justifyContent="space-between" gap={2}>
    <Typography color="text.secondary" fontSize={13} sx={{ flexShrink: 0 }}>
      {label}
    </Typography>
    <Typography fontSize={13} fontWeight={600} textAlign="left">
      {value}
    </Typography>
  </Stack>
);

export default TransactionCard;
